<div class="overflow-x-hidden">
    <div class="pb-5">
        <ng-content></ng-content>
    </div>

</div>
